"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconEngineFilled = function IconEngineFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "IconEngineFilled"), _react.default.createElement("path", {
    d: "M28.3942 14H18.4668C17.9577 14 17.6183 14.4315 17.6183 14.8631C17.6183 15.381 18.0425 15.7262 18.4668 15.7262H21.182V17.3661H18.4668C17.9577 17.3661 17.6183 17.7976 17.6183 18.2292V19.6964H15.0728C14.5637 19.6964 14.2243 20.128 14.2243 20.5595V25.1339H12.697V20.6458C12.697 20.128 12.2727 19.7827 11.8485 19.7827C11.3394 19.7827 11 20.2143 11 20.6458V31.6935C11 32.2113 11.4242 32.5565 11.8485 32.5565C12.3576 32.5565 12.697 32.125 12.697 31.6935V26.9464H14.2243V31.6071C14.2243 32.125 14.6485 32.4702 15.0728 32.4702H21.8608L24.2366 35.4048C24.4063 35.5774 24.6608 35.75 24.9154 35.75H32.9761C33.4852 35.75 33.8246 35.3185 33.8246 34.8869V31.4345H34.758V33.1607C34.758 33.6786 35.1822 34.0238 35.6065 34.0238H37.8126C38.152 34.0238 38.4914 33.7649 38.6611 33.4196C41.6308 25.6518 38.7459 20.8185 38.6611 20.6458C38.4914 20.3869 38.2368 20.2143 37.9823 20.2143H35.6065C35.0974 20.2143 34.758 20.6458 34.758 21.0774V22.631H33.8246L28.9882 17.4524H25.7639V15.7262H28.3942C28.9033 15.7262 29.2427 15.2946 29.2427 14.8631C29.2427 14.4315 28.9033 14 28.3942 14Z",
    fill: color
  }));
};

IconEngineFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconEngineFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconEngineFilled;
exports.default = _default;